import { Drawer, Portal, CloseButton } from '@chakra-ui/react';
import ViewContent from './view-content';

interface Props {
  isOpen: boolean;
  onClose(): void;
  content: any;
  drawerId?: string;
}

export default function ContentDrawer({ isOpen, onClose, content, drawerId }: Props) {
  return (
    <Drawer.Root
      id={`view-content-drawer-${drawerId}`}
      size='xl'
      placement='end'
      open={isOpen}
      onOpenChange={onClose}
    >
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.Body>
              <ViewContent data={content} />
            </Drawer.Body>
            <Drawer.CloseTrigger asChild>
              <CloseButton size='sm' />
            </Drawer.CloseTrigger>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}
